export default __webpack_public_path__ + "images/VW.60926e0.png";